module.exports = __webpack_public_path__ + "img/Step5m.3ab07c8a.png";